module.exports = __webpack_public_path__ + "static/media/YourStoryOurStory-1220x150px.6d0c9fad.webp";